import Vue from 'vue'
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Mousewheel,
  Scrollbar,
  Autoplay,
  EffectFade,
  Controller,
  Lazy,
  Thumbs,
} from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'

// Swiper modules
SwiperClass.use([
  Pagination,
  Navigation,
  Mousewheel,
  Scrollbar,
  Autoplay,
  EffectFade,
  Controller,
  Lazy,
  Thumbs,
])

// -------------------------------------------------

// Global use
Vue.use(getAwesomeSwiper(SwiperClass))

// -------------------------------------------------

// Or local component
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
}
